import React from 'react'

import SettingsDevices from 'Skelet/src/components/SettingsDevices.js'

import config from '../config.js'


export default class extends React.Component {

  render() {
    return <div className="container thin-container" style={{marginTop:"2em"}}>
      <SettingsDevices
        config = {config}
      />
    </div>;
  }

}



// WEBPACK FOOTER //
// ./src/containers/Settings.js